export default "__VITE_ASSET__DihF05HO__"